import { toastWarning, toastError } from 'admination-react'
import type { AppFailure } from './result'

export function toastBlocked(
  message: string = "Bitte zuerst alle rot markierten Felder ausfüllen.",
): void {
  toastWarning(message)
}

export function handleFailure(failure: AppFailure): void {
  toastError(failure.message)
}
